module.exports = __webpack_public_path__ + "static/media/java-plain.68655e08.svg";